import React from 'react';

import ContactAddressShow from '@components/shared/contact_addresses/ContactAddressShow';
import { useLoaderData } from 'react-router-dom';

const AdminContactAddressShow: React.FC = () => {
  const contactAddress = useLoaderData() as Parameters<typeof ContactAddressShow>[0]['contactAddress'];

  return (
    <ContactAddressShow
      contactAddress={contactAddress}
      role="admin"
    />
  );
};

export default AdminContactAddressShow;
